import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { retry, timer } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class RetryInterceptor implements HttpInterceptor {
  readonly maxRetries = 2
  readonly delay = 500

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return next
      .handle(request)
      .pipe(retry({ count: this.maxRetries, delay: (error: unknown) => this.delayNotifier(error) }))
  }

  delayNotifier(error: unknown) {
    if (error instanceof HttpErrorResponse && error.status === 0) {
      return timer(this.delay)
    }
    throw error
  }
}
